import { render, staticRenderFns } from "./KimsaLocationPicker.vue?vue&type=template&id=0d12c0ca&scoped=true&"
import script from "./KimsaLocationPicker.vue?vue&type=script&lang=js&"
export * from "./KimsaLocationPicker.vue?vue&type=script&lang=js&"
import style0 from "./KimsaLocationPicker.vue?vue&type=style&index=0&id=0d12c0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12c0ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDialog,VSheet})
